import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/index.scss'
import axios from 'axios';

Vue.use(ElementUI);
Vue.config.productionTip = false

Vue.prototype.$axios=axios

axios.defaults.baseURL = 'http://api.mcshandong.org/api/';
// axios.defaults.baseURL = 'http://shandong.lol/api/';
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
